import { Cession } from '../../../types/cession';

export const emptyCession: Cession = {
  clientId: '',
};
